const DropDownSelect = ({
  label = "Label",
  noDataMessage = "No course available",
  options = [],
  value,
  handleChange = () => {},
}) => {
  const onChange = (e) => {
    let filteredCourse = options.filter(
      (item) => item.courseName == e.target.value
    );
    filteredCourse = filteredCourse?.[0];
    handleChange(filteredCourse);
  };

  return (
    <div className="col-span-6 sm:col-span-6 lg:col-span-3 flex flex-col w-full">
      <p className="block text-[16px] font-medium">{label}</p>
      <select
        id="course"
        name="course"
        required
        value={value?.courseName}
        onChange={onChange}
        disabled={options.length < 1}
        className={`block h-10 lg:h-full w-full px-3 py-2 bg-white border border-gray-300 hover:border-blackText rounded-md shadow-sm focus:border-2 focus:border-indigo-700 focus:outline-none focus:ring-indigo-500 ${
          options.length > 0
            ? "hover:cursor-pointer"
            : "hover:cursor-not-allowed"
        }`}
      >
        {options.length > 0 ? (
          options.map((item, index) => (
            <option key={index} value={item?.courseName}>
              {item?.courseName}
            </option>
          ))
        ) : (
          <option value="" disabled selected>
            {noDataMessage}
          </option>
        )}
      </select>
    </div>
  );
};

export default DropDownSelect;
